import _implicitStylesheets from "./recommendationCarousel.css";
import _implicitScopedStylesheets from "./recommendationCarousel.scoped.css?scoped=true";
import _wdsContentTitle from "wds/contentTitle";
import _wdsButton from "wds/button";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "recommendation-band": true
};
const stc1 = {
  classMap: {
    "recommendation-band-inner": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "header": true
  },
  key: 2
};
const stc3 = {
  "carousel-track": true
};
const stc4 = {
  attrs: {
    "name": "cards"
  },
  key: 6
};
const stc5 = [];
const stc6 = {
  classMap: {
    "pagination": true
  },
  key: 7
};
const stc7 = {
  "arrow-btn": true
};
const stc8 = {
  "data-testid": "page-back"
};
const stc9 = {
  "data-testid": "page-forward"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element, gid: api_scoped_id, b: api_bind, ncls: api_normalize_class_name, s: api_slot} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [$cmp.hasItems ? api_element("section", {
    classMap: stc0,
    attrs: {
      "aria-label": $cmp.title
    },
    key: 0
  }, [api_element("div", stc1, [api_element("div", stc2, [api_custom_element("wds-content-title", _wdsContentTitle, {
    props: {
      "level": "2",
      "truncate": "false",
      "title": $cmp.title
    },
    key: 3
  })]), api_element("div", {
    classMap: stc3,
    attrs: {
      "id": api_scoped_id("recommendation-carousel-track")
    },
    key: 4,
    on: {
      "scroll": _m0 || ($ctx._m0 = api_bind($cmp.handleTrackScroll))
    }
  }, [api_element("ul", {
    className: api_normalize_class_name($cmp.carouselListClass),
    key: 5
  }, [api_slot("cards", stc4, stc5, $slotset)])]), $cmp.showPagination ? api_element("div", stc6, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc7,
    attrs: stc8,
    props: {
      "type": "button",
      "variant": "secondary",
      "icon": "back",
      "iconSpriteUrl": "/images/icons.svg",
      "name": "recommendation carousel previous",
      "ariaLabel": $cmp.effectivePreviousLabel,
      "ariaControls": api_scoped_id("recommendation-carousel-track"),
      "disabled": $cmp.backArrowDisabled
    },
    key: 8,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handlePageBack))
    }
  }), api_custom_element("wds-button", _wdsButton, {
    classMap: stc7,
    attrs: stc9,
    props: {
      "type": "button",
      "variant": "secondary",
      "icon": "forward",
      "iconSpriteUrl": "/images/icons.svg",
      "name": "recommendation carousel next",
      "ariaLabel": $cmp.effectiveNextLabel,
      "ariaControls": api_scoped_id("recommendation-carousel-track"),
      "disabled": $cmp.forwardArrowDisabled
    },
    key: 9,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.handlePageForward))
    }
  })]) : null])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["cards"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3krpc9a0id6";
tmpl.legacyStylesheetToken = "undefined-_recommendationCarousel";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
